import { __extends } from "tslib";
import { axCoerceString } from '@awayfl/avm2';
import { Debug } from '@awayjs/core';
import { TextJustifier } from './TextJustifier';
var EastAsianJustifier = /** @class */ (function (_super) {
    __extends(EastAsianJustifier, _super);
    function EastAsianJustifier(locale, lineJustification, justificationStyle) {
        if (locale === void 0) { locale = 'ja'; }
        if (lineJustification === void 0) { lineJustification = 'allButLast'; }
        if (justificationStyle === void 0) { justificationStyle = 'pushInKinsoku'; }
        var _this = this;
        locale = axCoerceString(locale);
        lineJustification = axCoerceString(lineJustification);
        justificationStyle = axCoerceString(justificationStyle);
        _this = _super.call(this, undefined, undefined) || this;
        return _this;
    }
    Object.defineProperty(EastAsianJustifier.prototype, "justificationStyle", {
        // AS -> JS Bindings
        // _justificationStyle: string;
        // _composeTrailingIdeographicSpaces: boolean;
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/engine/EastAsianJustifier', 'get justificationStyle', '');
            return null;
        },
        set: function (value) {
            value = axCoerceString(value);
            // @todo
            Debug.throwPIR('playerglobals/text/engine/EastAsianJustifier', 'set justificationStyle', '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EastAsianJustifier.prototype, "composeTrailingIdeographicSpaces", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/engine/EastAsianJustifier', 'get composeTrailingIdeographicSpaces', '');
            return null;
        },
        set: function (value) {
            // @todo
            Debug.throwPIR('playerglobals/text/engine/EastAsianJustifier', 'set composeTrailingIdeographicSpaces', '');
        },
        enumerable: true,
        configurable: true
    });
    EastAsianJustifier.forceNativeConstructor = true;
    EastAsianJustifier.forceNativeMethods = true;
    return EastAsianJustifier;
}(TextJustifier));
export { EastAsianJustifier };
